import { createPermissionsFactory } from '@/helper/createPermissionsFactory';

export default {
  computed: {
    permissions() {
      return this.$auth.user()?.permissions ?? createPermissionsFactory();
    }
  }
};
